import React, { useState, useCallback } from 'react';
import Toast from './Toast';
import './ToastContainer.css';

export const ToastContainer = React.forwardRef((props, ref) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((notification) => {
    const id = Math.random().toString(36).substr(2, 9);
    const toast = { id, ...notification };

    setToasts((prev) => [...prev, toast]);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  React.useImperativeHandle(ref, () => ({
    addToast,
    removeToast,
  }));

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          notification={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
});

ToastContainer.displayName = 'ToastContainer';

export default ToastContainer;


